import VOverflowBtn from './VOverflowBtn'

/* istanbul ignore next */
VOverflowBtn.install = function install (Vue) {
  Vue.component(VOverflowBtn.name, VOverflowBtn)
}

export { VOverflowBtn }
export default VOverflowBtn
